import client from '../utils/client'
import { gql } from '@apollo/client'
import { MutationHandlerErrorResult, MutationHandlerSuccessResult } from '../utils/errors'

const REQUEST_LOGIN_CODE_MUTATION = gql`
	mutation RequestLoginCode($email: String!) {
		requestLoginCode(email: $email) {
			success
		}
	}
`

const requestLoginCode = async ({
	email,
}: {
	email: string
}): Promise<MutationHandlerErrorResult | MutationHandlerSuccessResult> => {
	try {
		const { errors } = await client.mutate({
			mutation: REQUEST_LOGIN_CODE_MUTATION,
			variables: { email },
			errorPolicy: 'all',
		})
		if (errors) return { success: false, errors }
		return { success: true, errors: null }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default requestLoginCode
